import api from '../../api';

const sendContact = (fields) => api.post('/cms/contact_messages',fields)

export {
    sendContact
};